var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c(_vm.currentSlideFrame,{tag:"component",attrs:{"slideshow":_vm.slideshow}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }